import cx from 'clsx';
import Image from 'next/image';
import { useState } from 'react';

import {
  PromotionDetailsModal,
} from '@/app/_components/page_content/new-car-promo/promotion-details-modal';
import { createTimestampUid } from '@/utils/id';
import { joinSgcmMedia } from '@/utils/url/join/public';

import styles from './styles.module.scss';
import type { Component } from './types';

export const SponsoredContent: Component = ({
  promotions,
  modelId,
  className,
}) => {
  const promo = promotions
    .find(
      promotion => promotion.promoType === 'tactical_ads'
      && promotion.competitorCars?.find(id => id === modelId.toString()),
    );
  const [
    promotionDetailsModalKey,
    setPromotionDetailsModalKey,
  ] = useState(createTimestampUid);

  const [
    isPromotionDetailsModalOpen,
    setIsPromotionDetailsModalOpen,
  ] = useState(false);

  return promo && (
    <div className={cx(
      styles.containerRoot,
      className,
    )}>
      <PromotionDetailsModal
        key={promotionDetailsModalKey}
        isOpen={isPromotionDetailsModalOpen}
        promotion={promo}
        onClose={() => {
          setIsPromotionDetailsModalOpen(false);
          window.history.pushState(null, '', ' ');
        }}
        onExit={() => {
          setPromotionDetailsModalKey(createTimestampUid());
        }} />
      <button
        className={styles.containerCard}
        onClick={() => {
          setIsPromotionDetailsModalOpen(true);
        }}>
        <Image
          alt={promo.description}
          className={styles.image}
          height={60}
          layout="intrinsic"
          src={`${promo.isPremiumBanner
            ? `https://i.i-sgcm.com/new_cars/promos/${promo.dealer.id}/${promo.id}_customized_l.jpg`
            : joinSgcmMedia(`/public/new-cars/promos/${promo.dealer.id}/tactical-ads-${promo.id}-d-728x90.jpg`)}`}
          width={468} />
        <div className={styles.containerContent}>
          <span className={styles.textSponsoredContent}>Sponsored Content</span>
          <span className={styles.textTitle}>
            {`Latest ${promo.make} Promotion by ${promo.dealer.name}`}
          </span>
        </div>
      </button>
    </div>
  );
};
